const DisplayScorePlacements = {
    FIVE_POINT_BAR_GRAPH: 'fivePointBarGraph'
}

export default DisplayScorePlacements;
